module.exports = __webpack_public_path__ + "img/Z3RO.ec94671f.png";